import * as React from "react";
import {Business, CurrentUser, MenuSection} from "../../types/Types";
import {useState} from "react";
import {useEffect} from "react";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import {getLocation} from "../../utils/Utils";
import MenuSectionRow from "../../pages/menu/MenuSectionRow";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
  businessId: string
  displayConfigButtons: boolean,
}

function MenuList(props: Props) {
  const [menuSections, setMenuSections] = useState<Array<MenuSection>>([]);

  useEffect(() => {(async () => {
    if(!getLocation(props.businessId, props.businessMap)) {
      return
    }
    let menuSections = new Array<MenuSection>();
    const menuSectionCollections = query(
        collection(db, 'menu-sections'),
        where("location", "==", getLocation(props.businessId, props.businessMap)),
        orderBy("order", "asc"),
        limit(200),
    );
    const menuSectionsSnapshot = await getDocs(menuSectionCollections);
    menuSectionsSnapshot.forEach((doc) => {
      menuSections.push(doc.data() as MenuSection);
    });
    setMenuSections(menuSections);
  })();
  }, []);

  return (
      <div className={`${props.displayConfigButtons ? '' : 'list-bg'} mt-3`}>
          {/*<div className={"list-title"}>Menu</div>*/}
          {menuSections.map((menuSection, index) => (
              <div className={`${index == menuSections.length-1 ? 'mb-0' : 'mb-3'}`}>
                <MenuSectionRow currentUser={props.currentUser} businessMap={props.businessMap} menuSection={menuSection} displayConfigButtons={props.displayConfigButtons}/>
              </div>
          ))}
      </div>
  )
}

export default MenuList;